import { Component } from '@angular/core';
import { IconoirInfoCircle } from '@ey-xd/motif-icon';
import { MotifModule } from "@ey-xd/motif-wc-angular"; 
import { MotifProgressIndicator, MotifProgressIndicatorStep } from "@ey-xd/motif-wc-angular";

@Component({
  selector: 'app-tb-instructions',
  standalone: true,
  imports: [MotifModule],
  templateUrl: './tb-instructions.component.html',
  styleUrl: './tb-instructions.component.scss',
})
export class TbInstructionsComponent {
  IconoirInfoCircle = IconoirInfoCircle;
}
